module.exports = __webpack_public_path__ + "img/dj2.cba01199.svg";